<!-- ----------------------------- CP TEMPLATE ----------------------------- -->

<span *ngIf="cwd.context != 'link'">
    <div class="row" (dragover)="onDragOver($event)"
    (dragend)="onDragEnd($event)"
    (drop)="onDrop($event)"
    style="height: 100%;">
        <!-- menu -->
        <div class="right-menu affix">
            <div *ngIf="!canSave && previewonly">
                <i class="zmdi zmdi-eye zmdi-hc-lg"></i>
                Preview only
            </div>

            <ul
                *ngIf="cwd.type == 'dir' && (upload || showDownloadAll())"
                class="dropdown-menu right-menu-dropdown-menu dropdown-regular"
            >
                <li *ngIf="upload">
                    <a (click)="showTransfer()" class="showhand">
                        <i
                            class="zmdi zmdi-cloud-upload zmdi-hc-fw zmdi-hc-lg"
                        ></i>
                        Upload files
                    </a>
                </li>
                <li *ngIf="showDownloadAll()">
                    <a
                        (click)="downloadZipFile()"
                        title="Zip all files selected in the current directory"
                        class="showhand"
                    >
                        <i
                            class="zmdi zmdi-cloud-download zmdi-hc-fw zmdi-hc-lg"
                        ></i>
                        Download all
                    </a>
                </li>
            </ul>
        </div>
        <!-- menu -->

        <div class="col-sm-12 affix header-box-withmenu">
            <div class="header-title">
                <a
                    class="showhand"
                    *ngIf="!isRoot"
                    (click)="changeDir(cwd.pid, true)"
                >
                    <i class="zmdi zmdi-chevron-left zmdi-hc-lg syncblue"></i>
                </a>
                <strong>{{ cwd.name }}</strong>
            </div>

            <table class="table list-table list-table-header">
                <thead>
                    <tr>
                        <th class="table-filename">
                            Name <span class="caret"></span>
                        </th>
                        <th class="table-preview"></th>
                        <th class="table-date-link hidden-sm hidden-xs">Modified</th>
                        <th class="table-size hidden-sm hidden-xs">Size</th>
                        <th class="table-actions">
                            <!-- <i class="fas fa-th fa-sm fa-fw"></i> -->
                        </th>
                    </tr>
                </thead>
            </table>
        </div>
        <!-- col-sm-12 affix -->
    </div>
    <!-- row -->

    <div
        class="row xxxx"
        *ngIf="initialized"

    >
        <div id="upload-modal"></div>
        <div class="col-sm-12 content-box-withmenu" style="visibility: hidden">
            <div style="visibility: visible">
                <table class="table list-table">
                    <tbody>
                        <tr *ngIf="upload == UPLOAD_NON_VISIBLE">
                            <td>
                                <br /><br />
                                <h1>Upload files</h1>
                                <p>
                                    The owner of the link has made it
                                    upload-non-viewable
                                </p>
                            </td>
                        </tr>
                        <tr
                            *ngIf="
                                list.length == 0 && upload != UPLOAD_NON_VISIBLE
                            "
                        >
                            <td>
                                <div class="text-center">
                                    <h4>
                                        <img
                                            src="images/icons/dir.svg"
                                            width="36"
                                            height="36"
                                            style="padding-bottom: 4px"
                                        />
                                        Folder is empty
                                    </h4>

                                    <div
                                        class="file-empty-text"
                                        *ngIf="upload == UPLOAD_DISABLED"
                                    >
                                        This folder is empty
                                    </div>

                                    <div
                                        class="file-empty-text"
                                        *ngIf="upload != UPLOAD_DISABLED"
                                    >
                                        Upload folders or files by clicking the
                                        upload button to select files manually.
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr
                            id="sync-id-{{ item.sync_id }}"
                            *ngFor="
                                let item of list
                                    | slice
                                        : paginate.viewOffset
                                        : paginate.viewEnd
                            "
                        >
                            <td class="table-preview">
                                <img
                                    (click)="activate(item)"
                                    [src]="item.imgsrc"
                                />
                            </td>
                            <td class="table-filename">
                                <div class="tdmore">
                                    <span (click)="activate(item)">{{
                                        item.name
                                    }}</span>
                                    <br />
                                    <span
                                        *ngIf="
                                            item.transferitem &&
                                            item.type == 'file'
                                        "
                                    >
                                        <ngb-progressbar
                                            [max]="100"
                                            showValue="true"
                                            *ngIf="
                                                !item.transferitem.renderFile
                                                    .dl_ready
                                            "
                                            [value]="
                                                item.transferitem
                                                    .progress_percent
                                            "
                                        >
                                        </ngb-progressbar>

                                        <!-- error only -->
                                        <span
                                            *ngIf="
                                                item.transferitem.status > 1000
                                            "
                                        >
                                            {{ item.transferitem.status }}
                                        </span>
                                        <sync-save-file
                                            [syncSaveFile]="item.transferitem"
                                            [autodownload]="1"
                                        ></sync-save-file>
                                    </span>
                                </div>
                            </td>
                            <td class="table-date-link hidden-sm hidden-xs">
                                <div class="tdmore" *ngIf="item.type == 'file'">
                                    {{ item.date_medium }}
                                </div>
                                <div class="tdmore" *ngIf="item.type == 'dir'">
                                    --
                                </div>
                            </td>
                            <td class="table-size hidden-sm hidden-xs">
                                <div class="tdmore" *ngIf="item.type == 'file'">
                                    {{ item.size | bytesToSize }}
                                </div>
                                <div class="tdmore" *ngIf="item.type == 'dir'">
                                    --
                                </div>
                            </td>
                            <td class="table-actions">
                                <div
                                    ngbDropdown
                                    class="dropdown actions-dropdown"
                                    *ngIf="item.type == 'file'"
                                >
                                    <i
                                        ngbDropdownToggle
                                        class="fas fa-ellipsis-h pull-right dropdown-toggle"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="true"
                                    ></i>
                                    <ul
                                        ngbDropdownMenu
                                        class="dropdown-menu dropdown-regular"
                                    >
                                        <li
                                            *ngIf="
                                                !item.filetype.viewable &&
                                                previewonly
                                            "
                                            class="dropdown-header"
                                        >
                                            No actions available.
                                        </li>
                                        <li
                                            *ngIf="
                                                !item.transferitem &&
                                                item.filetype.viewable
                                            "
                                        >
                                            <a (click)="activate(item)">
                                                <i
                                                    class="zmdi zmdi-eye zmdi-hc-fw zmdi-hc-lg"
                                                ></i>
                                                Preview
                                            </a>
                                        </li>
                                        <li  *ngIf="isOpenable(item)"
                                >
                                    <a (click)="openFile(item)">
                                        <i class="zmdi zmdi-open-in-new zmdi-hc-fw zmdi-hc-lg"></i>
                                        Open
                                    </a>
                                </li>
                                        <li *ngIf="!previewonly">
                                            <a (click)="downloadFile(item)">
                                                <i
                                                    class="zmdi zmdi-cloud-download zmdi-hc-fw zmdi-hc-lg"
                                                ></i>
                                                Download
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="table-pagination pull-right">
                    <ngb-pagination
                        *ngIf="paginate.total > paginate.itemsPerPage"
                        [maxSize]="10"
                        [collectionSize]="paginate.total"
                        [(page)]="paginate.currentPage"
                        (pageChange)="onPageChange($event)"
                        [pageSize]="paginate.itemsPerPage"
                        [boundaryLinks]="true"
                    ></ngb-pagination>
                </div>

                <div class="table-info">
                    <!-- <i class="fas fa-info-circle"></i> -->
                    <span>
                        <sync-display-pagination [paginate]="paginate"></sync-display-pagination>
                    </span>
                </div>
            </div>
        </div>
        <!-- content box -->
    </div>
    <!-- row-->
</span>
<!-- ---------------------------- /CP TEMPLATE ----------------------------- -->

<!-- ------------------------ LINK CONSUME TEMPLATE ------------------------ -->
<span *ngIf="cwd.context == 'link'">
    <div class="row" (dragover)="onDragOver($event)"
    (dragend)="onDragEnd($event)"
    (drop)="onDrop($event)"
    style="height: 100%;">
        <!-- MAIN CONTENT COL -->
        <div class="col-md-8 col-lg-9">
            <!-- folder title row -->
            <div>
                <div class="header-title">
                    <a
                        class="showhand"
                        *ngIf="!isRoot"
                        (click)="changeDir(cwd.pid, true)"
                    >
                        <i
                            class="zmdi zmdi-chevron-left zmdi-hc-lg syncblue"
                        ></i>
                    </a>
                    <strong>{{ cwd.name }}</strong>
                </div>

                <table class="table list-table list-table-header">
                    <thead>
                        <tr>
                            <th class="table-filename" colspan="2">
                                Name <span class="caret"></span>
                            </th>
                            <th class="table-preview"></th>
                            <th class="table-date-link hidden-sm hidden-xs">Modified</th>
                            <th class="table-size hidden-sm hidden-xs">Size</th>
                            <th class="table-actions">
                                <!-- <i class="fas fa-th fa-sm fa-fw"></i> -->
                            </th>
                        </tr>
                    </thead>
                </table>
            </div>
            <!-- /folder title row -->

            <!-- notification toast message for secured upload link -->
                <div *ngIf="this.upload == 2 && isTransferComplete()" class="error-general-overlay">
                    <div class="row">
                        <div class="col-xs-9">
                            <i class='fas fa-check-circle'></i>
                            Files successfully uploaded, and will be visible only to the link owner.
                        </div>
                        <div class="col-xs-3 text-right"><i (click)="isTransfering = false" class="fas fa-times showhand"></i></div>
                    </div>
                </div>

            <div
                class="row xxxx"
                *ngIf="initialized"
                
            >
                <div id="upload-modal"></div>
                <div
                    class="content-box-withmenu-link"
                    style="visibility: hidden"
                >
                    <div style="visibility: visible">
                        <table class="table list-table">
                            <tbody>
                                <tr *ngIf="upload == UPLOAD_NON_VISIBLE">
                                    <td>
                                        <br /><br />
                                        <h1>Upload files</h1>
                                        <p>
                                            The owner of the link has made it
                                            upload-non-viewable
                                        </p>
                                    </td>
                                </tr>
                                <tr
                                    *ngIf="
                                        list.length == 0 &&
                                        upload != UPLOAD_NON_VISIBLE
                                    "
                                >
                                    <td>
                                        <div class="text-center">
                                            <h4>
                                                <img
                                                    src="images/icons/dir.svg"
                                                    width="36"
                                                    height="36"
                                                    style="padding-bottom: 4px"
                                                />
                                                Folder is empty
                                            </h4>

                                            <div
                                                class="file-empty-text"
                                                *ngIf="
                                                    upload == UPLOAD_DISABLED
                                                "
                                            >
                                                This folder is empty
                                            </div>

                                            <div
                                                class="file-empty-text"
                                                *ngIf="
                                                    upload != UPLOAD_DISABLED
                                                "
                                            >
                                                Upload folders or files by
                                                clicking the upload button to
                                                select files manually.
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr
                                    id="sync-id-{{ item.sync_id }}"
                                    *ngFor="
                                        let item of list
                                            | slice
                                                : paginate.viewOffset
                                                : paginate.viewEnd
                                    "
                                >
                                    <td class="table-preview">
                                        <img
                                            (click)="activate(item)"
                                            [src]="item.imgsrc"
                                        />
                                    </td>
                                    <td class="table-filename">
                                        <div class="tdmore">
                                            <span (click)="activate(item)">{{
                                                item.name
                                            }}</span>
                                            <br />
                                            <span
                                                *ngIf="
                                                    item.transferitem &&
                                                    item.type == 'file'
                                                "
                                            >
                                                <ngb-progressbar
                                                    [max]="100"
                                                    showValue="true"
                                                    *ngIf="
                                                        !item.transferitem
                                                            .renderFile.dl_ready
                                                    "
                                                    [value]="
                                                        item.transferitem
                                                            .progress_percent
                                                    "
                                                >
                                                </ngb-progressbar>

                                                <!-- error only -->
                                                <span
                                                    *ngIf="
                                                        item.transferitem
                                                            .status > 1000
                                                    "
                                                >
                                                    {{
                                                        item.transferitem.status
                                                    }}
                                                </span>
                                                <sync-save-file
                                                    [syncSaveFile]="item.transferitem"
                                                    [autodownload]="1"
                                                ></sync-save-file>
                                            </span>
                                        </div>
                                    </td>
                                    <td class="table-date-link hidden-sm hidden-xs">
                                        <div
                                            class="tdmore"
                                            *ngIf="item.type == 'file'"
                                        >
                                            {{ item.date_medium }}
                                        </div>
                                        <div
                                            class="tdmore"
                                            *ngIf="item.type == 'dir'"
                                        >
                                            --
                                        </div>
                                    </td>
                                    <td class="table-size hidden-sm hidden-xs">
                                        <div
                                            class="tdmore"
                                            *ngIf="item.type == 'file'"
                                        >
                                            {{ item.size | bytesToSize }}
                                        </div>
                                        <div
                                            class="tdmore"
                                            *ngIf="item.type == 'dir'"
                                        >
                                            --
                                        </div>
                                    </td>
                                    <td class="table-actions">
                                        <div
                                            ngbDropdown
                                            class="dropdown actions-dropdown"
                                            *ngIf="item.type == 'file'"
                                        >
                                            <i
                                                ngbDropdownToggle
                                                class="fas fa-ellipsis-h pull-right dropdown-toggle"
                                                data-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="true"
                                            ></i>
                                            <ul
                                                ngbDropdownMenu
                                                class="dropdown-menu dropdown-regular"
                                                style="z-index: 1100"
                                            >
                                                <li 
                                                    *ngIf="!compat && previewonly &&
                                                            !(this.fileItemService.isImage(item) || this.fileItemService.isText(item))"
                                                    class="dropdown-header">
                                                    Encrypted file. No actions available.
                                                </li>
                                                <li
                                                    *ngIf="
                                                        (!item.filetype.viewable &&
                                                        previewonly && 
                                                        !this.fileItemService.isStreamable(item.kind)) &&
                                                        compat
                                                    "
                                                    class="dropdown-header"
                                                >
                                                    No actions available.
                                                </li>
                                                <li *ngIf="isPreviewable(item)">
                                                    <a (click)="activate(item)">
                                                        <i class="zmdi zmdi-eye zmdi-hc-fw zmdi-hc-lg"></i>
                                                        Preview
                                                    </a>
                                                </li>
                                                <li *ngIf="isOpenable(item)">
                                                    <a (click)="openFile(item)">
                                                        <i class="zmdi zmdi-open-in-new zmdi-hc-fw zmdi-hc-lg"></i>
                                                        Open
                                                    </a>
                                                </li>
                                                <li *ngIf="!previewonly">
                                                    <a
                                                        (click)="
                                                            downloadFile(item)
                                                        "
                                                    >
                                                        <i
                                                            class="zmdi zmdi-cloud-download zmdi-hc-fw zmdi-hc-lg"
                                                        ></i>
                                                        Download
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="table-pagination pull-right">
                            <ngb-pagination
                                *ngIf="paginate.total > paginate.itemsPerPage"
                                [maxSize]="10"
                                [collectionSize]="paginate.total"
                                [(page)]="paginate.currentPage"
                                (pageChange)="onPageChange($event)"
                                [pageSize]="paginate.itemsPerPage"
                                [boundaryLinks]="true"
                            ></ngb-pagination>
                        </div>

                        <div class="table-info">
                            <!-- <i class="fas fa-info-circle"></i> -->
                            <span>
                                <sync-display-pagination [paginate]="paginate"></sync-display-pagination>
                            </span>
                        </div>
                    </div>
                </div>
                <!-- content box -->
            </div>
            <!-- row-->
        </div>
        <!-- /MAIN CONTENT COL -->

        <!-- MENU COL -->
        <div class="col-md-4 col-lg-3">
            <div class="right-menu-link right-menu-custom">
                <div *ngIf="!canSave && previewonly">
                    <i class="zmdi zmdi-eye zmdi-hc-lg"></i>
                    Preview only
                </div>

                <ul
                    *ngIf="cwd.type == 'dir' && (upload || showDownloadAll())"
                    class="dropdown-menu right-menu-dropdown-menu-link dropdown-regular syncblue-custom"
                >
                <li *ngIf="upload" class="showhand">
                    <a title="Upload" (click)="showfileTransferModal();">
                        <i ng-class="{
                            'zmdi zmdi-cloud-upload zmdi-hc-fw zmdi-hc-lg': !buildTransferItemService.view.isDownload,
                            'zmdi zmdi-cloud-download zmdi-hc-fw zmdi-hc-lg': buildTransferItemService.view.isDownload
                            }"
                            class="zmdi zmdi-cloud-upload zmdi-hc-fw zmdi-hc-lg"
                        ></i>
                        {{ buildTransferItemService.view.transferLabel }} 
                        <i *ngIf="buildTransferItemService.view.isDownload || buildTransferItemService.view.isUpload" class="fa fa-spin fa-sync fa-fw pull-right" style="margin-top:3px;"></i>
                    </a>
                </li>
                <li class="showhand" *ngIf="folderTransferView.isProcessing || folderTransferView.isScanning">
                    <a title="Upload" (click)="openUploadFolderModal()">
                        <i class="zmdi zmdi-hc-fw zmdi-hc-lg zmdi-cloud-upload"></i>
                        Uploading Folder
                        <i class="fa fa-spin fa-sync fa-fw pull-right" style="margin-top:3px;"></i>
                    </a>
                </li>
                    <li *ngIf="showDownloadAll()">
                        <a
                            (click)="downloadZipFile()"
                            title="Zip all files selected in the current directory"
                            class="showhand"
                        >
                            <i
                                class="zmdi zmdi-cloud-download zmdi-hc-fw zmdi-hc-lg"
                            ></i>
                            Download all
                        </a>
                    </li>
                </ul>
            </div>
            <!-- menu -->
            <sync-comment-block
                *ngIf="allowComment"
                [item]="cwd"
            ></sync-comment-block>
        </div>
        <!-- /MENU COL -->
    </div>
</span>

<!-- ----------------------- / LINK CONSUME TEMPLATE ----------------------- -->
